// pages/library.tsx
import { FC } from 'react';
import LibraryBrowser from '../components/LibraryBrowser';
import { useAuth } from '../contexts/AuthContext';

const Library: FC = () => {
  const { accessToken, isAuthenticated, login } = useAuth();

  if (!isAuthenticated) {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen p-4">
          <p className="text-lg mb-8 text-center">
            Please login to access your album library.
          </p>
          <button
              onClick={login}
              className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-full text-lg transition duration-300"
          >
            Login with Spotify
          </button>
        </div>
    );
  }

  return (
      <div className="page-container">
        {accessToken ? (
            <LibraryBrowser accessToken={accessToken} />
        ) : (
            <p className="text-center">Loading...</p>
        )}
      </div>
  );
};

export default Library;
